import clearNightSkyVideo from "../../../assets/footages/clearNightSky2.mp4";
import coudyNightSkyVideo from "../../../assets/footages/cloudyNightSky.mp4";
import clearNightRainVideo from "../../../assets/footages/clearNightRain.mp4";
import cloudyMorningVideo from "../../../assets/footages/cloudyMorning.mp4";
import clearMorningVideo from "../../../assets/footages/clearMorning3.mp4";
// Heavy overcast, no rain yet (e.g. today's F-11 reading: 26°C, 65% cloud cover).
import morningCloudyThunderVideo from "../../../assets/footages/morningCloudyThunder.mp4";
// Sun still visible through broken cloud with recent/imminent rain.
import sunnyCloudyRainVideo from "../../../assets/footages/sunnyCloudyRain.mp4";

export const WeatherSummary = ({ weatherData }) => {
  // Animated cloud component
  const Cloud = ({ delay = 0, size = 1, opacity = 0.7, speed = 20 }) => (
    <div
      style={{
        position: "absolute",
        left: "-100px",
        top: `${20 + Math.random() * 30}%`,
        width: `${80 * size}px`,
        height: `${40 * size}px`,
        background:
          "radial-gradient(ellipse at 30% 30%, rgba(255,255,255,0.9), rgba(255,255,255,0.3))",
        borderRadius: "100px",
        opacity: opacity,
        animation: `drift ${speed}s linear infinite`,
        animationDelay: `${delay}s`,
        filter: "blur(2px)",
        zIndex: 1,
      }}
    />
  );

  // Rain drop component
  const RainDrop = ({ left, delay }) => (
    <div
      style={{
        position: "absolute",
        left: `${left}%`,
        top: "-10px",
        width: "1px",
        height: "8px",
        background:
          "linear-gradient(to bottom, rgba(255,255,255,0.8), rgba(255,255,255,0.1))",
        animation: `fall 0.6s linear infinite`,
        animationDelay: `${delay}s`,
        opacity: 0.6,
      }}
    />
  );

  // Lightning flash
  const Lightning = ({ intensity = 1, delay = 0 }) => (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `radial-gradient(circle, rgba(255,255,255,${0.3 * intensity}), transparent)`,
        animation: `flash 2s ease-in-out infinite`,
        animationDelay: `${delay}s`,
        pointerEvents: "none",
      }}
    />
  );

  // Animated stars for night
  // const Star = ({ left, top, delay }) => (
  //   <div
  //     style={{
  //       position: 'absolute',
  //       left: `${left}%`,
  //       top: `${top}%`,
  //       width: '2px',
  //       height: '2px',
  //       background: '#ffffff',
  //       borderRadius: '50%',
  //       opacity: 0.8,
  //       animation: `twinkle 3s ease-in-out infinite`,
  //       animationDelay: `${delay}s`,
  //       boxShadow: '0 0 2px rgba(255,255,255,0.8)'
  //     }}
  //   />
  // );

  // Sun component
  // const Sun = () => (
  //   <div
  //     style={{
  //       position: 'absolute',
  //       top: '15%',
  //       right: '12%',
  //       width: '100px',
  //       height: '100px',
  //       background: 'radial-gradient(circle at 35% 35%, rgba(255,220,100,0.95), rgba(255,150,50,0.4))',
  //       borderRadius: '50%',
  //       filter: 'blur(8px)',
  //       opacity: 0.85,
  //       animation: `pulse 4s ease-in-out infinite`,
  //       boxShadow: '0 0 40px rgba(255,200,0,0.4)'
  //     }}
  //   />
  // );

  const now = new Date();
  const hour = now.getHours();

  // Daytime: 6 AM (6) to 6 PM (18)
  const isDayTime = hour >= 6 && hour < 18;
  const isNight = !isDayTime;

  // const isNight = weatherData?.temperature < 10 || weatherData?.description?.toLowerCase().includes('night');
  const isClear = weatherData?.cloudCover < 20;
  const isRainy = weatherData?.rainChance > 60;
  const isStormy = weatherData?.rainChance > 80;
  const isPartlyCloudy =
    weatherData?.cloudCover >= 20 && weatherData?.cloudCover < 60;
  // Heavy cloud cover but nothing falling yet — the "brewing storm" look.
  const isMostlyCloudy = weatherData?.cloudCover >= 60 && !isRainy;

  return (
    <>
      <style>{`
        @keyframes drift {
          from { transform: translateX(0px); }
          to { transform: translateX(calc(100% + 200px)); }
        }
        @keyframes fall {
          to { transform: translateY(100vh); }
        }
        @keyframes twinkle {
          0%, 100% { opacity: 0.2; }
          50% { opacity: 0.9; }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.8; }
          50% { transform: scale(1.1); opacity: 0.9; }
        }
        @keyframes flash {
          0%, 90%, 100% { opacity: 0; }
          95% { opacity: 0.6; }
        }
        @keyframes storm-flash {
          0%, 85%, 100% { opacity: 0; }
          90%, 92% { opacity: 0.8; }
        }
        @keyframes gentle-drift {
          0%, 100% { transform: translateX(0) translateY(0); }
          25% { transform: translateX(5px) translateY(-2px); }
          50% { transform: translateX(0) translateY(0); }
          75% { transform: translateX(-5px) translateY(2px); }
        }
      `}</style>

      <div
        style={{
          width: "25%",
          height: "100vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // filter: 'drop-shadow(0 0 20px rgba(255,200,100,0.3)) drop-shadow(0 0 40px rgba(255,150,50,0.2))'
        }}
      >
        {/* Weather content */}
        <div
          style={{
            position: "relative",
            zIndex: 10,
            height: "100%",
            background: "rgba(15, 15, 15, 0.6)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            borderRadius: "24px",
            padding: "40px 30px",
            // boxShadow: '0 0 10px rgba(255,200,100,0.4), 0 0 40px rgba(255,150,50,0.25), 0 8px 32px 0 rgba(0, 0, 0, 0.37)',
            // boxShadow: '0 0 10px rgba(50,120,220,0.4), 0 0 40px rgba(30,80,180,0.25), 0 8px 32px 0 rgba(0, 0, 0, 0.37)',
            boxShadow:
              "0 0 10px rgba(70,150,255,0.4), 0 0 40px rgba(50,120,220,0.25), 0 8px 32px 0 rgba(0, 0, 0, 0.37)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "auto",
            overflow: "hidden",
          }}
        >
          {/* Animated background elements - contained within card */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              overflow: "hidden",
              zIndex: 0,
              borderRadius: "20px",
              // background: isNight
              //   ? 'linear-gradient(135deg, rgba(10,22,40,0.3), rgba(26,40,71,0.3))'
              //   : isStormy
              //   ? 'linear-gradient(135deg, rgba(44,62,80,0.4), rgba(52,73,94,0.4))'
              //   : isRainy
              //   ? 'linear-gradient(135deg, rgba(70,80,90,0.3), rgba(80,90,100,0.3))'
              //   : isPartlyCloudy
              //   ? 'linear-gradient(135deg, rgba(100,110,130,0.2), rgba(110,120,140,0.2))'
              //   : 'linear-gradient(135deg, rgba(102,126,234,0.15), rgba(118,75,162,0.15))'
              background: isNight
                ? "linear-gradient(135deg, rgba(10,22,40,0.35), rgba(26,40,71,0.35))"
                : isStormy
                  ? "linear-gradient(135deg, rgba(60,70,90,0.35), rgba(90,100,120,0.35))"
                  : isRainy
                    ? "linear-gradient(135deg, rgba(90,110,130,0.3), rgba(120,140,160,0.3))"
                    : isPartlyCloudy
                      ? "linear-gradient(135deg, rgba(140,160,200,0.25), rgba(170,190,220,0.25))"
                      : "linear-gradient(135deg, rgba(135,180,255,0.25), rgba(255,215,130,0.25))",
            }}
          >
            {/* Clear sky - sun and gentle light */}
            {/* {isClear && !isNight && <Sun />} */}
            {/* {isDayTime && <Sun />} */}
            {isDayTime && isClear && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.7) contrast(1.05)",
                }}
              >
                <source src={clearMorningVideo} type="video/mp4" />
              </video>
            )}

            {/* Partly cloudy - fewer, slower moving clouds */}
            {isPartlyCloudy && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.7) contrast(1.05)",
                }}
              >
                <source src={cloudyMorningVideo} type="video/mp4" />
              </video>
            )}

            {/* Mostly/overcast cloudy, daytime - no rain falling yet */}
            {isDayTime && isMostlyCloudy && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.7) contrast(1.05)",
                }}
              >
                <source src={morningCloudyThunderVideo} type="video/mp4" />
              </video>
            )}

            {/* Sun still out through broken cloud, rain recent/imminent */}
            {isDayTime && isRainy && !isStormy && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.7) contrast(1.05)",
                }}
              >
                <source src={sunnyCloudyRainVideo} type="video/mp4" />
              </video>
            )}

            {/* Rainy - more clouds, rain effects */}
            {isRainy && !isStormy && (
              <>
                <Cloud delay={0} size={1.2} opacity={0.8} speed={18} />
                <Cloud delay={2} size={1} opacity={0.7} speed={20} />
                <Cloud delay={4} size={0.9} opacity={0.75} speed={22} />
                {[...Array(15)].map((_, i) => (
                  <RainDrop
                    key={i}
                    left={Math.random() * 100}
                    delay={Math.random() * 1}
                  />
                ))}
              </>
            )}

            {/* Stormy - heavy clouds, intense rain, lightning */}
            {isStormy && (
              <>
                <Lightning intensity={0.6} delay={0} />
                <Lightning intensity={0.4} delay={3} />
                <Cloud delay={0} size={1.4} opacity={0.85} speed={15} />
                <Cloud delay={1} size={1.3} opacity={0.8} speed={16} />
                <Cloud delay={3} size={1.2} opacity={0.82} speed={14} />
                {[...Array(25)].map((_, i) => (
                  <RainDrop
                    key={i}
                    left={Math.random() * 100}
                    delay={Math.random() * 0.8}
                  />
                ))}
              </>
            )}

            {/* Night sky - stars and subtle lighting */}
            {/* {isNight && (
              <>
                <Star left={12} top={10} delay={0} />
                <Star left={20} top={18} delay={0.5} />
                <Star left={32} top={12} delay={1} />
                <Star left={45} top={15} delay={1.5} />
                <Star left={58} top={20} delay={2} />
                <Star left={70} top={10} delay={2.5} />
                <Star left={82} top={25} delay={3} />
                <Star left={90} top={8} delay={3.5} />
                
                
                {isRainy && (
                  <>
                    <Cloud delay={0} size={1.1} opacity={0.6} speed={20} />
                    <Cloud delay={3} size={0.9} opacity={0.5} speed={22} />
                    {[...Array(10)].map((_, i) => (
                      <RainDrop key={i} left={Math.random() * 100} delay={Math.random() * 1} />
                    ))}
                  </>
                )}
              </>
            )} */}

            {isNight && isPartlyCloudy && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.7) contrast(1.05)",
                }}
              >
                <source src={coudyNightSkyVideo} type="video/mp4" />
              </video>
            )}

            {isNight && isRainy && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.7) contrast(1.05)",
                }}
              >
                <source src={clearNightRainVideo} type="video/mp4" />
              </video>
            )}

            {isNight && isClear && (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  zIndex: 0,
                  filter: "brightness(0.5) contrast(1.1)",
                }}
              >
                <source src={clearNightSkyVideo} type="video/mp4" />
              </video>
            )}
          </div>

          {/* Current temperature - large display */}
          <div
            style={{
              marginBottom: "40px",
              textAlign: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              style={{
                fontSize: "72px",
                fontWeight: "300",
                color: "#ffffff",
                lineHeight: "1",
                marginBottom: "10px",
              }}
            >
              {Math.round(weatherData.temperature)}°
            </div>
            <p
              style={{
                color: "#e0e0e0",
                fontSize: "18px",
                lineHeight: "1.6",
                fontWeight: "300",
                margin: 0,
              }}
            >
              {weatherData.description}
            </p>
          </div>

          {/* High/Low temps */}
          <div
            style={{
              // background: 'rgba(255,255,255,0.03)',
              background: isDayTime
                ? "rgba(0,0,0,0.35)"
                : "rgba(255,255,255,0.03)",
              padding: "20px 25px",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.06)",
              marginBottom: "25px",
              display: "flex",
              justifyContent: "space-around",
              position: "relative",
              zIndex: 1,
            }}
          >
            {/* Today's measured extremes from the same station serving the
                current reading (backend derives them from the AWS
                aggregate-day feed — the nowcast has no high/low field). */}
            <div style={{ textAlign: "center" }}>
              <span style={{ color: "#ffffff", fontSize: "13px" }}>High</span>
              <p
                style={{
                  color: "#FFB74D",
                  fontSize: "24px",
                  fontWeight: "300",
                  margin: "5px 0",
                }}
              >
                {Math.round(weatherData.tempHigh)}°
              </p>
            </div>
            <div
              style={{ width: "1px", background: "rgba(255,255,255,0.1)" }}
            />
            <div style={{ textAlign: "center" }}>
              <span style={{ color: "#ffffff", fontSize: "13px" }}>Low</span>
              <p
                style={{
                  color: "#4FC3F7",
                  fontSize: "24px",
                  fontWeight: "300",
                  margin: "5px 0",
                }}
              >
                {Math.round(weatherData.tempLow)}°
              </p>
            </div>
          </div>

          {/* Details grid */}
          <div
            style={{
              // background: 'rgba(255,255,255,0.03)',
              background: isDayTime
                ? "rgba(0,0,0,0.35)"
                : "rgba(255,255,255,0.03)",
              padding: "25px",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.06)",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div>
              <span
                style={{
                  color: "#c2c2c2",
                  fontSize: "13px",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Humidity
              </span>
              <p
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "300",
                  margin: 0,
                }}
              >
                {Math.round(weatherData.humidity)}%
              </p>
            </div>
            <div>
              <span
                style={{
                  color: "#c2c2c2",
                  fontSize: "13px",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Wind
              </span>
              <p
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "300",
                  margin: 0,
                }}
              >
                {Math.round(weatherData.windSpeed)} km/h
              </p>
            </div>
            <div>
              <span
                style={{
                  color: "#c2c2c2",
                  fontSize: "13px",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Clouds
              </span>
              <p
                style={{
                  color: "#90A4AE",
                  fontSize: "20px",
                  fontWeight: "300",
                  margin: 0,
                }}
              >
                {Math.round(weatherData.cloudCover)}%
              </p>
            </div>
            <div>
              <span
                style={{
                  color: "#c2c2c2",
                  fontSize: "13px",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Rain
              </span>
              <p
                style={{
                  color: "#64B5F6",
                  fontSize: "20px",
                  fontWeight: "300",
                  margin: 0,
                }}
              >
                {Math.round(weatherData.rainChance)}%
              </p>
            </div>
            <div>
              <span
                style={{
                  color: "#c2c2c2",
                  fontSize: "13px",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Heat Index
              </span>
              <p
                style={{
                  color: "#FFB74D",
                  fontSize: "20px",
                  fontWeight: "300",
                  margin: 0,
                }}
              >
                {Math.round(weatherData.heatIndex)}°C
              </p>
            </div>
            <div>
              <span
                style={{
                  color: "#c2c2c2",
                  fontSize: "13px",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Dew Point
              </span>
              <p
                style={{
                  color: "#4FC3F7",
                  fontSize: "20px",
                  fontWeight: "300",
                  margin: 0,
                }}
              >
                {Math.round(weatherData.dewPoint)}°C
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
